import { ModalRef } from '@msdk/common'
import { styled } from '@msdk/ui'
import React, { Suspense } from 'react'

interface Props {
  modalRef?: ModalRef
  children: React.ReactElement
}

const SuspenseWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;

  > * {
    min-width: 0;
    max-width: 100%;
  }

  .MuiDialogContent-root:has(> &) {
    padding: 0;
    overflow-y: hidden;
    display: flex;
  }
`
/**
 * Wrapper to ensure the modalRef to a specific modal is passed down to the modal itself.
 * Creates a clone of the passed child and injects the modalRef, wrapping it in a suspense to prevent flickering.
 */
export function ModalSuspenseWrapper(props: Props) {
  const { children, modalRef } = props

  const child = React.cloneElement(children, { ...children.props, modalRef })

  return (
    <SuspenseWrapper>
      <Suspense>{child}</Suspense>
    </SuspenseWrapper>
  )
}
